import React from 'react';
import {Input, Pagination, Select} from "antd";
import ContactCard from "./ContactCardFlex";
import {connect} from "react-redux";
import {currentEffectiveUserId} from "../../reducers/ui";

const simpleSort = (a, b, c = 0) => a > b ? 1 : a < b ? -1 : c;

const lowerOrNull = a => a ? a.toLocaleLowerCase() : null;

const nameSort = (a, b) =>
  simpleSort(lowerOrNull(a.firstname), lowerOrNull(b.firstname),
    simpleSort(lowerOrNull(a.lastname), lowerOrNull(b.lastname),
      simpleSort(lowerOrNull(a.email), lowerOrNull(b.email))));

class _ContactsView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      pageSize: 15,
    }
  }

  componentDidMount() {
    const { onMount } = this.props;
    if (onMount) onMount();
  }

  componentDidUpdate(prevProps) {
    const { page, pageSize } = this.state;
    const { contacts } = this.props;
    const { contacts: prevItems } = prevProps;
    if (contacts !== prevItems && ((page - 1) * pageSize) > contacts.length) {
      this.setState({ page: 1 });
    }
  }

  setPagination = (page, pageSize) => {
    this.setState({ page });
  };

  setPageSize = (current, size) => {
    const { contacts } = this.props;

    this.setState({ pageSize: size });

    let page = current;
    const max_page = Math.ceil(contacts.length / size);
    if (page > max_page) {
      page = max_page;
      this.setState({ page });
    }
  };

  render() {
    const { contacts, extras, currentUser } = this.props;
    const { page, pageSize } = this.state;
    contacts.sort(nameSort);
    const itemsCut = contacts.slice((page - 1) * pageSize, page * pageSize);
    return (
      <div>
        <div className='contacts-header'>
          <div>
            <Pagination
              simple
              total={contacts.length}
              showSizeChanger
              onShowSizeChange={this.setPageSize}
              showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
              current={page}
              onChange={this.setPagination}
              pageSize={pageSize}
            />
          </div>
          <div>
            <Input.Group compact>
              <Input addonBefore='Page Size' style={{width: 90}}/>
              <Select addonBefore={'Page Size'} value={pageSize} onSelect={v => this.setPageSize(page, v)}>
                <Select.Option value={15}>15 / page (5 rows)</Select.Option>
                <Select.Option value={30}>30 / page (10 rows)</Select.Option>
                <Select.Option value={60}>60 / page (20 rows)</Select.Option>
                <Select.Option value={120}>120 / page (40 rows)</Select.Option>
              </Select>
            </Input.Group>
          </div>
        </div>
        <div className='contacts-body'>
          {itemsCut.map(contact => {
            let computedExtras = extras ? extras(contact, currentUser) : null;
            return <ContactCard
              id={contact.contactuserid}
              key={contact.contactuserid}
              extra={computedExtras}
              loader={this.props.loader}
              path={this.props.path}
            />
          })}
        </div>
        <div className='contacts-footer'>
          <Pagination
            total={contacts.length}
            showSizeChanger
            onShowSizeChange={this.setPageSize}
            pageSizeOptions={['15', '30', '60', '120']}
            showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
            current={page}
            onChange={this.setPagination}
            pageSize={pageSize}
            hideOnSinglePage
          />
        </div>
      </div>
    );
  }
}

export const ContactsView = connect(
  (state, props) => ({ currentUser: currentEffectiveUserId(state) })
)(_ContactsView);



// WEBPACK FOOTER //
// ./src/components/Boilerplate/ContactsView.js